__turbopack_context__.v({
  "brandLtr": "company-hero-module__kZ0eWW__brandLtr",
  "content": "company-hero-module__kZ0eWW__content",
  "hero": "company-hero-module__kZ0eWW__hero",
  "heroHeader": "company-hero-module__kZ0eWW__heroHeader",
  "heroHeaderContainer": "company-hero-module__kZ0eWW__heroHeaderContainer",
  "heroHeaderHighlight": "company-hero-module__kZ0eWW__heroHeaderHighlight",
  "heroImage": "company-hero-module__kZ0eWW__heroImage",
  "heroLogo": "company-hero-module__kZ0eWW__heroLogo",
  "heroLogoInner": "company-hero-module__kZ0eWW__heroLogoInner",
  "heroSubhead": "company-hero-module__kZ0eWW__heroSubhead",
  "heroTaglinesContainer": "company-hero-module__kZ0eWW__heroTaglinesContainer",
  "heroText": "company-hero-module__kZ0eWW__heroText",
});
